import { Form, Formik } from 'formik';
import React, { memo, useContext, useEffect, useState, useRef, useMemo } from 'react';
import { useSelector } from 'react-redux';
import * as Yup from 'yup';

import { Button, Footer, ShowArrowButton } from '../..';
import utils from '../../../services/utils';
import Context from '../../../store/context';
import ResumePay from '../../../pages/payments/Payout/ResumePay/ResumePay';
import CardBankAccountPay from './CardBankAccountPay/CardBankAccountPay';
import useGet from '../../../services/hooks/http/useGet';
import CardPSEPay from './CardPSEPay/CardPSEPay';
import apiMethods from '../../../apis';
// CYBERSOURCE DESHABILITADO TEMPORALMENTE
// import CardCybersourcePay from './CardCybersourcePay/CardCybersourcePay';
import InternationalBankDeposit from './InternationalBankDeposit/InternationalBankDeposit';

import classes from './OriginAccount.module.scss';

//const initialValueFormik = { radio: 'no', firstAccountValue: '', secondAccountValue: '', numberInputs: 0, methodForPay: '', sourceAccountsToPay: [] }
const initialValueFormik = {
  firstAccountValue: 0,
  numberInputs: 0,

  sourceAccountsToPay: [],
  isPaymentWithMultipleAccounts: 'no'
};
const OriginAccount = ({
  onAccept,
  totalValueToPay,
  suppliersGrouping,
  isShowDetailMobil,
  showDetailMobil,
  invoiceAndSupplier,
  setSuppliersGrouping,
  costTransaction,
  footer,
  onPaymentMethodChange,
  isInternational = false,
  pricingData
}) => {
  const {
    toast: { showError },
    modal: { showError: showErrorModal }
  } = useContext(Context);

  const { businessId, businesses } = useSelector(state => state.userData);
  const { defaultDruoAccountId } = businesses?.[businessId] || {};

  const [methodForPay, setMethodForPay] = useState('');
  const [newInitialValuesFormik, setNewInitialValuesFormik] = useState(null);
  // CYBERSOURCE DESHABILITADO TEMPORALMENTE
  // const cybersourceRef = useRef(null);

  const {
    isSuccess: getDruoConnectionsSuccess,
    data: getDruoConnectionsData,
    isError: getDruoConnectionsError,
    errorMessage
  } = useGet(apiMethods.getDruoConnections, [businessId]);

  // Memoizar druoAccounts para evitar re-renders infinitos en CardBankAccountPay
  // Ordenar con la cuenta predeterminada primero
  const druoAccounts = useMemo(() => {
    const accounts = (getDruoConnectionsData || []).map(druoBank => ({
      ...druoBank,
      identificationTypeLabel: druoBank.endUser?.identificationTypeLabel || '',
      identificationNumber: druoBank.endUser?.identificationNumber || ''
    }));

    // Si hay cuenta predeterminada, ponerla primero
    if (defaultDruoAccountId && accounts.length > 0) {
      return [...accounts].sort((a, b) => {
        if (a.druoAccountId === defaultDruoAccountId) return -1;
        if (b.druoAccountId === defaultDruoAccountId) return 1;
        return 0;
      });
    }

    return accounts;
  }, [getDruoConnectionsData, defaultDruoAccountId]);

  const validationSchemaValue = Yup.object().shape({
    firstAccountValue: Yup.number().when('isPaymentWithMultipleAccounts', {
      is: 'yes',
      then: Yup.number().when('numberInputs', {
        is: value => value === 2,
        then: Yup.number()
          .max(totalValueToPay, 'Este monto supera el total')
          .when('numberInputs', {
            is: 2,
            then: Yup.number().min(1, 'Este monto debe ser mayor que 0'),
            otherwise: Yup.number().min(totalValueToPay, 'El monto debe ser igual al total a pagar')
          })

          .required('Se debe colocar el valor a pagar'),
        otherwise: Yup.number().notRequired()
      }),
      otherwise: Yup.number().notRequired()
    })
  });

  //const [sourceAccountsToPay, setFieldsState] = useState([]);
  const [pseAccountSelected, setPseAccountSelected] = useState({ pseCustomerIndex: '' });

  // Notificar cuando se seleccione un método de pago
  useEffect(() => {
    if (onPaymentMethodChange) {
      if (methodForPay === 'PSEPay') {
        onPaymentMethodChange('PSEPay');
      } else if (methodForPay === 'bankAccount') {
        onPaymentMethodChange('bankAccount');
      } else {
        onPaymentMethodChange('');
      }
    }
  }, [methodForPay, onPaymentMethodChange]);

  useEffect(() => {
    if (isInternational) {
      setMethodForPay('international');
    }
  }, [isInternational]);

  useEffect(() => {
    if (getDruoConnectionsSuccess && methodForPay === 'bankAccount') {
      //setIsNotFirstFetchForBankAccount(false);
      /*   setDruoaccounts(
        getDruoConnectionsData.map(druoBank => ({
          ...druoBank,
          identificationTypeLabel: druoBank.endUser.identificationTypeLabel,
          identificationNumber: druoBank.endUser.identificationNumber
        }))
      ); */
      setNewInitialValuesFormik({
        ...initialValueFormik,
        sourceAccountsToPay: /*  getDruoConnectionsData.length === 1
            ? [
                {
                  value: totalValueToPay,
                  druoAccountId: getDruoConnectionsData[0].druoAccountId,
                  bankId: getDruoConnectionsData[0].bankId,
                  subtypeLabel: getDruoConnectionsData[0].subtypeLabel,
                  bankLast4Digits: getDruoConnectionsData[0].bankLast4Digits,
                  name: getDruoConnectionsData[0].owner,
                  identification: `${getDruoConnectionsData[0].endUser.identificationTypeLabel} ${getDruoConnectionsData[0].endUser.identificationNumber}`
                }
              ]
            : */ []
      });
    } else if (getDruoConnectionsError) {
      showErrorModal({ title: 'Cuentas bancarias', description: errorMessage });
    }
  }, [
    methodForPay,
    errorMessage,
    getDruoConnectionsData,
    getDruoConnectionsError,
    getDruoConnectionsSuccess,
    showErrorModal,
    totalValueToPay
  ]);

  // Si se pide una por defecto agregar este objeto en el State de "sourceAccountsToPay"
  /*  {
    value: totalValueToPay,
    druoAccountId: druoAccounts[0].druoAccountId,
    druoBankId: druoAccounts[0].druoBankId,
    subtypeLabel: druoAccounts[0].subtypeLabel,
    bankLast4Digits: druoAccounts[0].bankLast4Digits,
    name: druoAccounts[0].owner,
    identification: `${druoAccounts[0].identificationTypeLabel} ${druoAccounts[0].identificationNumber}`
  } */

  const payInvoices = async values => {
    if (methodForPay === 'international') {
      // Para usuarios internacionales, ya se maneja en el componente InternationalBankDeposit
      onAccept(methodForPay, [{ isInternational: true }]);
    } else if (methodForPay === 'bankAccount') {
      if (values.isPaymentWithMultipleAccounts === 'yes' && values.sourceAccountsToPay.length === 1) {
        showError('Debe seleccionar otra cuenta de origen para dividir el monto');
        return;
      }
      if (values.sourceAccountsToPay.length === 0) {
        showError('No se ha seleccionado una cuenta de origen');
        return;
      }

      if (values.sourceAccountsToPay.some(({ value }) => value === 0)) {
        showError('Una de las cuentas de origen no tiene un monto digitado');
        return;
      }

      if (totalValueToPay !== values.sourceAccountsToPay.reduce((prev, { value }) => prev + value, 0)) {
        showError('El total de las cuentas no es igual al total a pagar');
        return;
      }

      onAccept(methodForPay, values.sourceAccountsToPay);
    } else if (methodForPay === 'PSEPay') {
      if (!!!pseAccountSelected) {
        showError('No se ha seleccionado una cuenta PSE');
        return;
      }

      onAccept(methodForPay, [{ ...pseAccountSelected }]);
    } else if (!!!methodForPay) {
      showError('No se ha seleccionado ningun metodo de pago');
    }
  };

  const invoicesSelected = (suppliersGrouping || []).reduce((prev, { invoices }) => prev + invoices.length, 0);

  const setShowMethodPay = type => {
    const newMethod = prevMethodPay => (prevMethodPay === type ? '' : type);
    setMethodForPay(newMethod);
    
    // Notificar al componente padre sobre el cambio de método de pago
    if (onPaymentMethodChange) {
      const finalMethod = methodForPay === type ? '' : type;
      onPaymentMethodChange(finalMethod);
    }
  };

  return (
    <div className={classes.container}>
      <Formik
        enableReinitialize
        initialValues={newInitialValuesFormik || initialValueFormik}
        validationSchema={validationSchemaValue}
        onSubmit={isInternational ? () => {} : payInvoices}>
        {({ values }) => (
          <Form className={classes.form} id='originAccountForm'>
            {isInternational ? (
              <InternationalBankDeposit
                onAccept={onAccept}
                totalValueToPay={totalValueToPay}
                costTransaction={costTransaction}
                suppliersGrouping={suppliersGrouping}
                pricingData={pricingData}
              />
            ) : (
              <>
                <span className={`${classes.title} bold-24`}>Selecciona el método de pago</span>
            <CardBankAccountPay
              setShowMethodPay={setShowMethodPay}
              sourceAccountsToPay={values.sourceAccountsToPay}
              open={methodForPay === 'bankAccount'}
              totalValueToPay={totalValueToPay}
              defaultDruoAccountId={defaultDruoAccountId}
              druoAccounts={druoAccounts}
            />
            <CardPSEPay
              businessId={businessId}
              pseAccountSelected={pseAccountSelected}
              setPseAccountSelected={setPseAccountSelected}
              open={methodForPay === 'PSEPay'}
              setShowMethodPay={setShowMethodPay}
            />
            {/* Comentado temporalmente - Solo mostrar pagos bancarios y PSE */}
            {/* <CardCybersourcePay
              businessId={businessId}
              open={methodForPay === 'cybersource'}
              setShowMethodPay={setShowMethodPay}
              totalValueToPay={totalValueToPay}
              onPaymentSuccess={(paymentData) => {
              }}
            /> */}

            <Footer isExpanded={isShowDetailMobil}>
              {footer ? (
                footer
              ) : (
                <div className={classes.footer}>
                  <div className={classes['footer-info']}>
                    <div className={classes.details}>
                      <span className={classes['selected-mobile']}>
                        {invoicesSelected} Cuentas de cobro de {suppliersGrouping.length} proveedores
                      </span>
                      <ShowArrowButton showState={isShowDetailMobil} reverse={true} onClick={showDetailMobil} />
                    </div>

                    <div className={classes.totals}>
                      <div className={classes['total-main']}>
                        <span className='bold-20'>TOTAL </span>
                        <span className='bold-20'>{utils.moneyFormat(totalValueToPay)}</span>
                      </div>
                      <span className={`${classes['total-explanation']} medium-12`}>
                        *Fees de transacción: <span style={{ textDecoration: 'line-through', opacity: 0.7 }}>{utils.moneyFormat(costTransaction * suppliersGrouping.length)}</span> (Descuento especial)
                      </span>
                    </div>
                    {isShowDetailMobil && (
                      <ResumePay
                        costTransaction={costTransaction}
                        isMobil={true}
                        invoiceAndSupplier={invoiceAndSupplier}
                        suppliersGrouping={suppliersGrouping}
                        setSuppliersGrouping={setSuppliersGrouping}
                        totalValueToPay={totalValueToPay}
                        methodForPay={methodForPay}
                        showFee={true}
                      />
                    )}
                    <span className={classes.selected}>{invoicesSelected} cuentas de cobro seleccionadas</span>
                  </div>
                  <Button
                    type='submit'
                    form='originAccountForm'
                    className={classes['button-pay']}
                    custom='primary'
                    color='purple'
                    name='continue'>
                    Continuar
                  </Button>
                </div>
              )}
            </Footer>
              </>
            )}
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default memo(OriginAccount);
